<template>
    <div class="row">
        <div class="col-md-8">
            <div class="row mb-4">
                <div class="col-md-6">
                    <div :class="currentStep == 1 ? 'step-title active' : 'step-title'">انتخاب تصویر</div>
                </div>
                <div class="col-md-6">
                    <div :class="currentStep == 3 ? 'step-title active' : 'step-title'">تایید و افزودن به سبد</div>
                </div>
                <div class="col-md-12 mt-4">
                    <div :style="{display: currentStep == 1 ? 'unset' : 'none'}">
                        <div class="row create-cart-box justify-content-center text-center" v-if="imageSrc">
                            <p class="w-100">تصویر مورد نظر خود را انتخاب کنید</p>
                            <div class="col-md-8 text-center">
                                <img id="image" :src="imageSrc">
                                <button :class="(!imageUrl ? 'btn btn-custom ml-1 btn-dark mt-3' : 'btn btn-custom ml-1 btn-dark')" @click="changeImage">تغییر تصویر</button>
                                <button :class="(!imageUrl ? 'btn btn-primary btn-custom mt-3' : 'btn btn-primary btn-custom')" @click="currentStep++">مرحله بعد</button>
                            </div>
                        </div>
                        <div class="row justify-content-center text-center" v-else>
                            <p class="w-100 mb-4">تصویر مورد نظر خود را انتخاب کنید</p>
                            <div class="col-12 mb-4">
                                <div class="row">
                                    <div class="col-md-3 text-right">
                                        <label class="rdiobox"><input name="rdio" type="radio" value="all" v-model="imagesType" checked> <span>همه تصاویر</span></label>
                                    </div>
                                    <div class="col-md-3 text-right">
                                        <label class="rdiobox"><input name="rdio" type="radio" value="system" v-model="imagesType"> <span>تصاویر پیشفرض</span></label>
                                    </div>
                                    <div class="col-md-3 text-right">
                                        <label class="rdiobox"><input name="rdio" type="radio" value="user" v-model="imagesType"> <span>تصاویر آپلود شده</span></label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" v-if="imagesType != 'new'">
                                <div class="row" v-if="images.length">
                                    <div class="col-md-4 mb-3" v-for="(image,index) in images" :key="index">
                                        <div class="custom-image-parent-org">
                                            <img class="organization-image" @click="setImageId(image.mediaId)" :src="`https://cardapi.sabinarya.com/${image.picUrl}`" alt="">
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-else>
                                    <div class="col-md-12">
                                        <div class="alert alert-info">
                                            <p class="mb-0">تصویری یافت نشد</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="currentStep == 2">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row justify-content-center">
                                    <div class="col-md-5 pl-0">
                                        <div class="form-group">
                                            <label>تعداد</label>
                                            <input type="number" min="0" class="form-control ltr-input" placeholder="تعداد" value="0" v-model="itemsCount" @keyup="e => itemsCount = parseInt(itemsCount)">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 text-center">
                                <button class="btn btn-primary btn-custom wizard-button ml-1 mt-1" v-if="imageUrl == ''" @click="currentStep--">مرحله قبل</button>
                                <button class="btn btn-success btn-custom wizard-button mt-1" :disabled="disableButton || (itemsCount && itemsCount < 1)" @click="saveImage" v-if="imageUrl == ''">تایید و افزودن به سبد</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <h6 class="custom-card-box-title">پیش نمایش</h6>
            <hr class="mb-4">
            <div id="preview-parent">
                <div id="preview-container" class="mt-3">
                    <img src="/assets/img/giftcard.png" class="card-template">
                    <div id="preview"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Cropper from 'cropperjs';
import 'vue-slider-component/theme/antd.css';
import 'verte/dist/verte.css';
import html2canvas from 'html2canvas';

export default {
    name: 'CustomCard',
    props: ['addToCard','depositsList'],
    data(){
        return {
            cardType: 3,
            imageSrc: '',
            imageUrl: '',
            customText: '',
            depositId: 0,
            optionalCredit: '',
            itemsCount: 0,
            textColor: 'rgb(244, 244, 244)',
            borderColor: 'rgb(244, 244, 244)',
            fontSize: 14,
            borderSize: 0,
            disableButton: false,
            cardText: '',
            price: 0,
            currentStep: 1,
            allImages: [],
            images: [],
            fontName: 'IRANSansFa',
            imagesType: 'all',
            imageMediaId: 0,
            mainImageData: '',
            uploadImage: false
        }
    },
    watch: {
        fontSize(value){
            document.getElementById('inner-element').style.fontSize = (value * 2.5) + 'px';
        },
        borderSize(value){
            document.getElementById('inner-element').style.webkitTextStrokeWidth = value + 'px';
        },
        imagesType(value){
            this.uploadImage = false;
            if(value == 'all')
                this.images = this.allImages;
            else if(value == 'system')
                this.images = this.allImages.filter(image => image.byAdmin)
            else if(value == 'user')
                this.images = this.allImages.filter(image => !image.byAdmin)
            else
                this.uploadImage = true;
        }
    },
    methods: {
        setImage(e){
            let reader = new FileReader();
            reader.onload = e => {
                this.imageSrc = e.target.result;
                this.mainImageData = e.target.result;
            }
            reader.readAsDataURL(e.target.files[0]);
            setTimeout(() => {
                const image = document.getElementById('image');
                new Cropper(image,{
                    aspectRatio: 91.00 / 58.00,
                    viewMode: 1,
                    preview: '#preview',
                    autoCropArea: 0.8,
                    dragMode: 'move'
                });
            },100);
        },
        async setImageId(id){
            this.imageMediaId = id;
            const result = await this.$api.get('Organizations/Media/' + this.imageMediaId);
            this.imageSrc = 'data:image/jpeg;base64,' + result.data.base64;
            this.mainImageData = 'data:image/jpeg;base64,' +  result.data.base64;
            setTimeout(() => {
                const image = document.getElementById('image');
                new Cropper(image,{
                    aspectRatio: 91.00 / 58.00,
                    viewMode: 1,
                    preview: '#preview',
                    autoCropArea: 0.8,
                    dragMode: 'move'
                });
            },100);
        },
        changeImage(){
            this.imageSrc = '';
            this.imageUrl = '';
            document.getElementsByClassName('cropper-container')[0].remove();
            document.getElementById('preview').childNodes[0].remove();
        },
        handleMinAndMax(){
            let value = this.optionalCredit ? this.optionalCredit.replace(/,/gi,'') : 0;
            if(value < 200000){
                this.$swal({
                    icon: 'error',
                    title: 'خطا',
                    text: 'کمترین مبلغ شارژ 200,000 ریال می باشد'
                });
                this.optionalCredit = '';
            }
        },
        cardTextChecker(){
            this.cardText = this.cardText.replace(/[0-9]/g,'');
        },
        changeCustomDepositValue(e){
            let value = this.optionalCredit ? this.optionalCredit.replace(/,/gi,'') : 0;
            let numbers = /^[0-9]*$/;
            if(!numbers.test(e.target.value)){
                e.preventDefault();
            }
            if(value > 20000000)
                value = 20000000;
            value = new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(value);
            if(value == 'NaN')
                value = '';
            this.optionalCredit = value;
        },
        setTextColor(color,e = null){
            let buttons = document.querySelectorAll('.text-color-button');
            for(let button in buttons)
                if(typeof buttons[button] == 'object')
                    buttons[button].classList.remove('active');
            if(e != null && typeof e == 'object')
                e.target.classList.add('active');
            document.getElementById('inner-element').style.color = color;
            this.textColor = color;
        },
        setBorderColor(color,e = null){
            let buttons = document.querySelectorAll('.stork-color-button');
            for(let button in buttons)
                if(typeof buttons[button] == 'object')
                    buttons[button].classList.remove('active');
            if(e != null && typeof e == 'object')
                e.target.classList.add('active');
            document.getElementById('inner-element').style.webkitTextStrokeColor = color;
            this.borderColor = color;
        },
        async saveImage(){
            this.disableButton = true;
            document.getElementById('preview-container').style.transform = 'unset';
            html2canvas(document.getElementById('preview-container')).then(canvas => {
                this.imageUrl = canvas.toDataURL('image/png');
            });
            document.getElementById('preview-container').style.transform = 'scale(0.32)';
            await html2canvas(document.getElementById('preview-container')).then(canvas => {
                let base64Data = canvas.toDataURL('image/png').replace('data:image/png;base64,','');
                this.minifyImageUrl = 'data:image/png;base64,' + base64Data;
            });
            let metaData = [
                {
                    key: 2,
                    base64: this.imageUrl
                },
                {
                    key: 81,
                    base64: this.mainImageData
                },
                {
                    key: 3,
                    base64: this.cardText
                }
            ];
            this.addToCard(0,'کارت هدیه فیزیکی دلخواه',this.cardType,this.itemsCount,this.price,this.minifyImageUrl,metaData,this.imageMediaId);
            this.imageSrc = '';
            this.imageUrl = '';
            document.getElementsByClassName('cropper-container')[0].remove();
            document.getElementById('preview').childNodes[0].remove();
            this.disableButton = false;
            this.currentStep = 1;
            this.depositId = 0;
            this.optionalCredit = '';
            this.itemsCount = 0;
            this.imageSrc = '';
            this.cardText = '';
            this.imageUrl = '';
            this.textColor = 'rgb(244, 244, 244)';
            this.borderColor = 'rgb(244, 244, 244)';
            this.fontSize = 14;
            this.borderSize = 0;
            if(document.getElementById('preview-img'))
                document.getElementById('preview-img').setAttribute('src','');
        }
    },
    created(){
        this.$api.get('Config/CustomCost').then(({data}) => {
            this.price = 10000;//parseInt(data.result);
        });
        this.$api.get('Organizations/Media?Option=2').then(({data}) => {
            if(data.status && data.result.length){
                this.images = data.result.filter(image => image.metadataKeyId == 2 && image.isApproved);
                this.allImages = data.result.filter(image => image.metadataKeyId == 2 && image.isApproved);
            }
        });
    }
}
</script>